type ReplaceEmptyKey<T, R extends string> = {
    [K in keyof T as K extends "" ? R : K]: T[K] extends (...args: any[]) => any
        ? T[K]
        : T[K] extends object
        ? ReplaceEmptyKey<T[K], R>
        : T[K];
};

export function replaceEmptyKeys<T extends object, R extends string>(obj: T, replacementKey: R): ReplaceEmptyKey<T, R> {
    if (typeof obj !== "object" || obj === null || typeof obj === "function") {
        return obj as ReplaceEmptyKey<T, R>;
    }

    if (Array.isArray(obj)) {
        return obj.map((item) => replaceEmptyKeys(item, replacementKey)) as unknown as ReplaceEmptyKey<T, R>;
    }

    return Object.entries(obj).reduce((acc, [key, value]) => {
        const newKey = (key === "" ? replacementKey : key) as keyof ReplaceEmptyKey<T, R>;
        const newValue =
            typeof value === "object" && value !== null && typeof value !== "function"
                ? replaceEmptyKeys(value as any, replacementKey)
                : value;
        (acc as any)[newKey] = newValue;
        return acc;
    }, {} as ReplaceEmptyKey<T, R>);
}
